export const getAspectRatio = ({ width, height }) =>
  width && height ? width / height : 16 / 9;

export const getRatioHeight = ({ width, height, actualWidth }) => {
  if (!height && !width) {
    return {
      _: undefined,
      m: undefined,
    };
  }

  if (!width || !actualWidth) {
    return {
      _: undefined,
      m: height,
    };
  }

  const ratioHeight = (actualWidth * height) / width;

  if (ratioHeight > height) {
    return {
      _: undefined,
      m: height,
    };
  }

  return {
    _: undefined,
    m: ratioHeight,
  };
};
